import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addStudentOrder, getStudentOrder, delStudentOrder, getOrderCount, getRelatives, getUserInfoByPhone, getBookedPeriodCount } from '@/api/module/user';
import { GetAge } from '@/assets/utils/utils';
import { Dialog, Toast } from "vant";
import { encrypt } from '../../assets/utils/cryptoUtil.js';
export default {
  name: "index",
  data: function data() {
    return {
      minDate: new Date(),
      maxDate: new Date(),
      bookedPatient: undefined,
      loginuser: undefined,
      checkDate: undefined,
      amPm: '1',
      amPmText: '9:00-11:45',
      orderCount: [],
      orderArr: new Array(),
      userInfo: {},
      //个人信息
      relatives: [],
      //亲属信息
      checkUser: [],
      checkInfo: {},
      periodList: [],
      //时间段可预约人数
      periodValue: '',
      //已选择的时间段
      periodText: ''
    };
  },
  created: function created() {
    //登录用户信息
    var loginuser = JSON.parse(localStorage.getItem("loginuser"));

    if (loginuser != null) {
      this.loginuser = loginuser;
    }

    this.getOrder();
    this.getCount();
    this.getUserList();
  },
  filters: {
    valueFilter: function valueFilter(value) {
      if (value == '1') {
        return '9:00-11:45';
      } else if (value == '2') {
        return '12:00-16:00';
      }
    },
    sexFilter: function sexFilter(value) {
      if (value == '0') {
        return '女';
      } else if (value == '1') {
        return '男';
      }
    }
  },
  methods: {
    getAgeByIdCard: function getAgeByIdCard(idcard) {
      return GetAge(idcard);
    },
    getUserList: function getUserList() {
      var _this = this;

      //查询客户和亲属信息
      var param = {
        phone: encrypt(JSON.parse(localStorage.getItem("loginuser")).phone)
      };
      getUserInfoByPhone(param).then(function (res) {
        if (res.code == 200) {
          _this.userInfo = res.data;

          if (_this.userInfo.idcard == null || _this.userInfo.idcard == undefined || _this.userInfo.idcard == '') {
            Toast.fail('请您完善个人信息！');

            _this.$router.push({
              name: 'edituser'
            });
          } else {
            _this.checkInfo = res.data;
          }

          getRelatives(param).then(function (res) {
            //2025-07-03 luotong 处理PatientID加密出错导致的出错
            if (res.data == -1 && res.msg === "参数patientid错误") {
              Dialog({
                message: "登录过期，返回重新登录",
                theme: 'round-button'
              }).then(function () {
                window.localStorage.removeItem("loginuser");
                localStorage.removeItem("token");

                _this.$router.push({
                  name: 'login'
                });
              });
            }

            if (res.code == 200) {
              _this.relatives = res.data;
            }
          });
        }
      });
    },
    formatter: function formatter(day) {
      var year = day.date.getFullYear();
      var month = day.date.getMonth() + 1;
      var date = day.date.getDate();

      if (month < 10) {
        month = '0' + month;
      }

      if (date < 10) {
        date = '0' + date;
      }

      var days = year + '-' + month + '-' + date;
      this.orderCount.forEach(function (item) {
        if (item.bookedDate == days) {
          if (item.enable == '0') {
            day.bottomInfo = '休息';
            day.type = "disabled";
          } else if (item.enable == '1') {
            if (item.childCount <= '0') {
              day.bottomInfo = '余 0';
              day.type = "disabled";
            } else {
              day.bottomInfo = '余 ' + item.childCount;
            }
          }
        }
      }); //将所有的没有排期的设置为休息日

      if (!this.orderArr.includes(days)) {
        var nextMonthStr = "";
        var nextMonth = this.getNextMonth();
        var nextM = nextMonth.getMonth() + 1;
        var nextD = nextMonth.getDate();

        if (nextM < 10) {
          nextM = '0' + nextM;
        }

        if (nextD < 10) {
          nextD = '0' + nextD;
        }

        nextMonthStr = nextMonth.getFullYear() + '-' + nextM + '-' + nextD; //已经过去的时间不显示文字

        if (days >= this.getNow() && days <= nextMonthStr) {
          day.bottomInfo = '休息';
          day.type = "disabled";
        }
      }

      return day;
    },
    //查询预约排班
    getCount: function getCount() {
      var _this2 = this;

      getOrderCount().then(function (res) {
        if (res.code == 200) {
          _this2.orderCount = res.data;

          _this2.orderCount.forEach(function (item) {
            _this2.orderArr.push(item.bookedDate + '');
          });

          _this2.maxDate = _this2.getNextMonth();
        }

        _this2.selectDate(new Date());

        _this2.getPeriod();
      });
    },
    //根据体检日期获取时间段可预约人数
    getPeriod: function getPeriod() {
      var _this3 = this;

      //如果当天不能预约，则不查询
      if (this.checkDate) {
        var param = {
          checkDate: this.checkDate
        };
        getBookedPeriodCount(param).then(function (res) {
          if (res.code == 200) {
            _this3.periodList = res.data;
          }
        });
      }
    },
    //取消预约
    del: function del() {
      var _this4 = this;

      Dialog.confirm({
        title: '提示？',
        message: '确认要取消预约吗'
      }).then(function () {
        var param = {
          id: _this4.bookedPatient.id
        };
        delStudentOrder(param).then(function (res) {
          if (res.code == 200) {
            Toast.success('取消预约成功');

            _this4.$router.push({
              name: 'home'
            });
          }
        });
      }).catch(function () {});
    },
    //添加订单
    addOrder: function addOrder() {
      var _this5 = this;

      if (this.checkDate == undefined) {
        Toast.fail('请选择体检时间');
        return;
      }

      if (this.periodValue == '') {
        Toast.fail('请选择体检时间段');
        return;
      }

      if (this.checkUser.length == 0) {
        Toast.fail('请选择体检人员');
        return;
      } //如果约当天的，则10点半后不能再预约


      var checkDay = this.checkDate.substring(8, 10);
      var d = new Date();

      if (d.getDate() + '' == checkDay) {
        //判断当前几点
        if (d.getHours() > '10') {
          Toast.fail('抱歉，10点半后不能预约当天体检');
          return;
        } else if (d.getHours() == '10') {
          if (d.getMinutes() > '30') {
            Toast.fail('抱歉，10点半后不能预约当天体检');
            return;
          }
        }
      } //如果预约人数大于剩余人数，则提示不能预约
      //获取可预约人数


      var can = this.periodList.filter(function (item) {
        return item.id == _this5.periodValue;
      })[0].surplus;

      if (this.checkUser.length > can) {
        Toast.fail('您选择的体检人数超过可预约人数');
        return;
      }

      var str = '您预约的体检时间为：' + this.checkDate + ' ' + this.periodText + '，' + '您确定要预约吗？';
      Dialog.confirm({
        title: '提示',
        message: str
      }).then(function () {
        var param = {
          userId: _this5.loginuser.id,
          checkDate: _this5.checkDate,
          periodId: _this5.periodValue,
          checkUserId: _this5.checkUser.join(',')
        };
        addStudentOrder(param).then(function (res) {
          if (res.code == 200) {
            _this5.getOrder();

            Toast.success('预约成功');
          }
        });
      }).catch(function () {});
    },
    //查询学生体检订单
    getOrder: function getOrder() {
      var _this6 = this;

      var param = {
        userId: this.loginuser.id
      };
      getStudentOrder(param).then(function (res) {
        if (res.code == 200) {
          _this6.bookedPatient = res.data;

          if (_this6.bookedPatient == null) {
            Dialog.alert({
              title: '温馨提示',
              message: '  目前只针对小学至大学入学体检，其他体检请勿预约。幼儿及入托体检请到门诊儿科挂号。'
            }).then(function () {// on close
            });
          }
        }
      });
    },
    changeText: function changeText() {
      var _this7 = this;

      this.periodValue;
      this.periodText = this.periodList.filter(function (item) {
        return item.id == _this7.periodValue;
      })[0].beginTime + '-' + this.periodList.filter(function (item) {
        return item.id == _this7.periodValue;
      })[0].endTime;
    },
    formatDate: function formatDate(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();

      if (month < 10) {
        month = '0' + month;
      }

      if (day < 10) {
        day = '0' + day;
      }

      return "".concat(year, "-").concat(month, "-").concat(day);
    },
    selectDate: function selectDate(date) {
      this.checkDate = this.formatDate(date);
      this.getPeriod();
    },
    getNextMonth: function getNextMonth() {
      var d = new Date();
      d.setMonth(d.getMonth() + 1);
      d.setDate(d.getDate() - 1);
      var yy1 = d.getFullYear();
      var mm1 = d.getMonth();
      var dd1 = d.getDate();
      return new Date(yy1, mm1, dd1);
    },
    getNow: function getNow() {
      var d = new Date();
      var yy1 = d.getFullYear();
      var mm1 = d.getMonth() + 1;

      if (mm1 < 10) {
        mm1 = '0' + mm1;
      }

      var dd1 = d.getDate();

      if (dd1 < 10) {
        dd1 = '0' + dd1;
      }

      return yy1 + '-' + mm1 + '-' + dd1;
    }
  }
};